import { useEffect, useRef } from 'react';
import { StrategyPositionSnapshot } from '../../../types/trading';
import { toFiniteNumber } from './formatters';

export function useStrategyLegEntryBasis(strategyPositions: StrategyPositionSnapshot[]) {
  const basisRef = useRef<Record<string, number>>({});

  useEffect(() => {
    const activeKeys = new Set<string>();
    strategyPositions.forEach((sp) => {
      sp.legs.forEach((leg) => {
        const key = `${sp.strategy_position_id}:${leg.leg_id}`;
        activeKeys.add(key);
        const recorded = toFiniteNumber(leg.avg_price);
        if (recorded != null) basisRef.current[key] = recorded;
      });
    });
    Object.keys(basisRef.current).forEach((k) => {
      if (!activeKeys.has(k)) delete basisRef.current[k];
    });
  }, [strategyPositions]);

  return basisRef;
}
